import { Stack, StackProps, styled } from '@mui/material';
import { hexToRgba } from '../../utils/color';

export const Root = styled((props: StackProps) => (
  <Stack justifyContent="center" alignItems="center" {...props} />
))(({ theme }) => ({
  position: 'fixed',
  inset: 0,
  backgroundColor: hexToRgba(theme.palette.common.black, 0.6),
  zIndex: 9999,
}));
